// extracted by mini-css-extract-plugin
export default {"fieldset":"styles_fieldset__NenKI","labelWrapper":"styles_labelWrapper__GjCxp","title":"styles_title__asIDg","description":"styles_description__QXIjJ"};